<template>
  <CContainer class="d-flex content-center min-vh-100">
    <CRow>
      <CCol>
        <CCardGroup>
          <CCard class="p-4">
            <CCardBody>
              <CForm>
                <h1>Login</h1>
                <p class="text-muted">Sign In to your account</p>
                <CAlert show color="danger" v-if='message!=""'>{{message}}</CAlert>
                
                <CInput
                  placeholder="Username"
                  autocomplete="username email"
                  v-model="login"
                >
                  <template #prepend-content><CIcon name="cil-user"/></template>
                </CInput>
                <CInput
                  placeholder="Password"
                  type="password"
                  autocomplete="curent-password"
                   v-model="password"
                >
                  <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                </CInput>
                  <CButton color="success" block @click='loginAction()'>Login</CButton>
              </CForm>
            </CCardBody>
          </CCard>
        </CCardGroup>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
       password: '',
       login: '',
       message: ''
    }
  },
  methods: {
    loginAction () {
      let self = this;
      self.message = '';
        this.$api
        .post('login', {
          login: this.login,
          password: this.password
        })
        .then(function (responce){
           if(responce.data.status == 'success'){
             localStorage.setItem("access_token", responce.data.token);
             self.$router.push({ path: '/' })
           }else{
              self.message = responce.data.message;
           }
        });
    }
  },
  mounted: function () {
    const token = localStorage.getItem("access_token");
    if (token) {
      this.$router.push({ path: '/' })
    }
  } 
}
</script>
